import { mapGeoPoint } from '@/entities/order/lib/mapGeoPoint'
import { buildCourierOrderUi } from '@/entities/order/model/courierOrderFlow'
import { normalizeOrderStatus } from '@/entities/order/model/normalizeOrderStatus'
import { mapOrderPaymentFields } from '@/entities/payment/model/orderPayment'
import { resolveProductImageUrl } from '@/entities/product/lib/resolveProductImages'

export function mapCourierOrder(dto) {
  if (!dto || typeof dto !== 'object') {
    return null
  }

  const restaurantTitle = String(dto.restaurant?.title ?? '').trim()
  const restaurantId =
    dto.resto_id != null && dto.resto_id !== '' ? String(dto.resto_id) : null

  const order = {
    id: String(dto.id ?? dto._id ?? ''),
    status: normalizeOrderStatus(dto.status),
    restaurantId,
    restaurantTitle,
    restaurantLocation: mapGeoPoint(dto.restaurant?.location),
    deliveryAddress: dto.address ?? '',
    deliveryLocation: mapGeoPoint(dto.location),
    items: mapCourierOrderItems(dto.items),
    totalAmount: Number(dto.total_price ?? 0),
    ...mapOrderPaymentFields(dto),
    currency: 'VND',
    createdAt: dto.created_at ?? null,
    updatedAt: dto.updated_at ?? null,
    acceptedAt: dto.timestamps?.courier_accepted_at ?? null,
    courierAssignedAt: dto.timestamps?.courier_assigned_at ?? null,
    pickedUpAt: dto.timestamps?.picked_up_at ?? null,
    deliveredAt: dto.timestamps?.delivered_at ?? null,
  }

  order.courierUi = buildCourierOrderUi(order)
  return order
}

export function mapCourierOrderList(dtos) {
  if (!Array.isArray(dtos)) {
    return []
  }
  return dtos.map(mapCourierOrder).filter(Boolean)
}

function mapCourierOrderItems(items) {
  if (!Array.isArray(items)) {
    return []
  }

  return items.map((item) => ({
    id: String(item.product_id ?? item.id ?? ''),
    title: item.title ?? '',
    quantity: Number(item.quantity ?? 1),
    price: Number(item.price ?? 0),
    imageUrl: resolveProductImageUrl(item),
  }))
}
